import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import staticProfile from "@Images/NewUI/staticimg.png";
import email_img from "@Images/NewUI/email.png";
import smartphone from "@Images/NewUI/smartphone.png";
import user_icon from "@Images/NewUI/user.png";
import HistoryHere from "@Images/NewUI/hystoryhere.png";
import support_icon from "@Images/NewUI/headset.png";
import policy_icon from "@Images/NewUI/privacy-policy.png";
import referNew from "@Images/NewUI/refernew.png";
import referandearn from "@Images/NewUI/refernearn.png";
import logout_icon from "@Images/NewUI/log-out.png";
import emandate from "@Images/NewUI/emandate.png";
import ekyc from "@Images/NewUI/approve.png";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { profilePicture } from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus,referandearndiraction } from "../../../Redux/Manual_Kyc_Details/action";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import close from "../../../../src/Images/NewUI/close.png";

const ProfileMenu = (props) => {
  // console.log("profle data test", props);
  let token = props?.user?.manual_token;
  const [profilePicture, setProfilePicture] = useState();
  const [loader, setLoader] = useState(false);
  const [plJourneyCheck , setPlJourneyCheck] = useState(false)
  

  const checkBankVerified = () => {
    setLoader(true)
    let token = localStorage.getItem("gpay_token");
    props.getDocumentStatus(token)
      .then((res) => {
        
        res.data.map((details) => {
          setPlJourneyCheck(details?.pl_journey)
        //  console.log(details.pl_journey, "details get doc status");

         
        });
      })
      .catch((err) => {
        setLoader(false)
        if (err.response?.status === 401) {
        //  window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        
      });
  };

  const handleReferandEarn = () => {
   
  
    let token = props.token || localStorage.getItem("gpay_token");
    props.referandearndiraction(token)
      .then((res) => {
        // console.log(res, "res of web view url");
        
        setTimeout(() => {
          window.open(res.data.url, '_blank');
        }, 100); 
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleprofilePicture = () => {
    props
      .profilePicture("", token)
      .then((res) => {
        setProfilePicture(res?.data?.presigned_url);
        // console.table("response loan history", res);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
        //  window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  useEffect(() => {

    props
    .getUserDetail(token)
    .then((res) => {
      if (res.status === 200) {
        console.log("User details fetched successfully:", res?.email);
        console.log("User details fetched successfully:", res?.customusermodel?.first_name);
        console.log("User details fetched successfully:", res?.customusermodel?.first_name);
        
        
      } else {
        console.error("Unexpected response:", res);
      }
    })
    .catch((error) => {
      console.error("Error fetching user details:", error);
    });
  

  
    handleprofilePicture();
    checkBankVerified()
  }, []);

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = "/";
  };

  return (
    <div id="background" className="main_div ">
      <div  className="container centerer">
        <div className="pb-4 ">
          {/* <Heading headingText={HEADING_BLANK} history={props.history} /> */}
          <div className="mt-50">
            
          </div>
          <div className="profile_upper_info flex align-center">
            <img
              src={profilePicture ? profilePicture : staticProfile}
              className="profilepicturesize"
              alt="profile"
            />
            <div className="right_p_info">
              <p className="user_p_name">
              {props?.userDetail?.user_detail?.customusermodel?.first_name
    .split(' ')[0]
    .charAt(0)
    .toUpperCase() + props?.userDetail?.user_detail?.customusermodel?.first_name
    .split(' ')[0]
    .slice(1)
    .toLowerCase() || "User"}
              </p>
              <span className="user_email mb-10">
                <img src={email_img} alt="email" />
                {props?.userDetail?.user_detail?.email}
              </span>
              
              <span className="user_no">
                <img src={smartphone} alt="smartphone" />
                {props?.userDetail?.user_detail?.customusermodel?.phone_number}
              </span>
            </div>
          </div>
          <div className="profile_lower_sc ">
            <ul>
              <Link
                to={{ pathname: "/profile_view", profile_pic: profilePicture }}
              >
                <li className="profileMenutext">
                  <img width={51}  src={user_icon} alt="user" />
                  Your Account
                </li>
              </Link>
              {/* <hr className="horizontalline"/> */}

              {/* <Link to="/security_privacy">
                <li>
                  <img src={security_icon} alt="security" />
                  Security & Privacy
                </li>
              </Link> */}
              <hr className="horizontalline"/>
              <Link
                to={{ pathname: "/loanhistory", profile_pic: profilePicture }}
              >
                <li className="profileMenutext">
                <img src={HistoryHere} alt="user" style={{ width: "54px" }} />
                  History
                </li>
              </Link>
              <hr className="horizontalline"/>
              <Link to="/raise_ticket"
              >
                <li className="profileMenutext">
                  <img src={support_icon} alt="support" />
                  Support
                </li>
              </Link>
              <hr className="horizontalline"/>
              <Link to="/new_policies"
              >
                <li className="profileMenutext">
                  <img width={51} src={policy_icon} alt="policy" />
                  Policies
                </li>
              </Link>
              <hr className="horizontalline"/>


              <div onClick={handleReferandEarn} className="refer-earn-new">
                <li className="profileMenutext">
                  <img width={54} src={referandearn} alt="policy" />
                  Refer And Earn
                </li>
              <img src={referNew} width={56} height={26} alt="refernew" />
              </div>
              <hr className="horizontalline"/>


              {plJourneyCheck &&
              <>
              <Link to="/completeprofilenew"
              >
                
                <li className="profileMenutext">
                  <img src={ekyc} style={{width:48}} alt="policy" />
                  Documents
                </li>
              </Link>
              <hr className="horizontalline"/>
              </>
              }
              <a href="https://www.paymeindia.in/our-nbfc-partners/"
              >
                <li className="profileMenutext">
                  <img src={emandate} style={{width:52}} alt="policy" />
                  NBFC partners
                </li>
              </a>
              <hr className="horizontalline"/>

              <Link
                to="#"
                onClick={() => {
                  handleLogout();
                }}
              >
                <li className="profileMenutext">
                  <img src={logout_icon} alt="logout" /> Logout
                </li>
              </Link>
            </ul>
          </div>
          <span className="headingprofile_menu">
              <img className="profilemenuxbtn" style={{cursor:"pointer"}}  src={close}  onClick={() => {
                window.location.href="/dashboard_s"
        
      }} />
              </span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default connect(mapStateToProps, { profilePicture,referandearndiraction,getUserDetail, getDocumentStatus })(ProfileMenu);